import { apiSlice } from "../apiSlice";

export interface GetCartResponse {
  items: any;
}

export interface GetSearchCart {
  params?: string;
  query?: string,
  filters?: string
}

export interface UpdateCartRequest {
  cartId: any;
  cartStatus: any;
}

export interface UpdateCartDetailsRequest {
  cartId: string;
  displayName?: string;
  abbreviation?: string;
  restaurantIds?: any;
  merchantId?: string;
  canSelfRegisterCarts?: boolean;
  cartLocation?: Location;
  isFixedLocation?: boolean;
  address?:string;
  supportedChannels?:string[];
  cartType?:string;
  deliveryCartsIds?:string[];
}

export interface CartPersonIdentityDocumentExtntionRequest {
  documentType: string;
  fileExtension: string;
}

export type LogoFileExtntionRequest = {
  fileExtention: string;
};

export type LogoFileExtntionResponse = {
  result: {
    imageReference: string;
    imageUploadUrl: string;
  };
};

export interface CartImageUpdateRequest {
  imgRef: string;
  cartId: string;
}

export interface CreateCartPerson {
  displayName: string;
  email: string;
  phoneNumber: string;
  identityDocReference: string;
  imageReference: string;
  canSelfRegisterCarts: boolean;
  canCollectCash: boolean;
}

type Location = {
  latitude: any;
  longitude: any;
};

export interface CreateCart {
  ownerId?: string;
  displayName: string;
  cartLocation: Location;
  imageReference: string;
  isFixedLocation: boolean;
}

export interface CartStatusOnline {
  cartId: string;
  cartState: string;
  reasonForBeingOffline: string;
}

export interface CartPersonAssign {
  cartId: string;
  cartPersonId: string | undefined;
}

export interface CartPersonNonAssign {
  cartPersonId: string | undefined;
}

export interface CartPersonImageUpdateRequest {
  imageRef: string;
  cartPersonId?: string;
  oldImgUrl?: string;
}

export interface cartPersonBankDataUpdateRequest {
  cartPersonId: string;
  accountName: string;
  accountNumber: string;
  bankName: string;
  branchName: string;
  swiftCode: string;
}

export interface cartPersonWalletUpdateRequest {
  merchantId: string;
  amount: number;
}

export interface SettleCartPaymentRequest {
  cartId: string;
  amount: number;
  restaurantId: string;
}

const API_BASE_DOMAIN = process.env.REACT_APP_API_BASE_DOMAIN_PRODUCTION;
const ALGOLIA_APP_ID = process.env.REACT_APP_ALGOLIA_APP_ID;
const ALGOLIA_API_KEY = process.env.REACT_APP_ALGOLIA_API_KEY;

export const cartSearchService = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getAllCartDetails: builder.query({
      query: () =>
        `https://superadminhttps-getallcarts-${API_BASE_DOMAIN}-uc.a.run.app?status=All`,
    }),
    getCartsByStatus: builder.mutation<GetCartResponse, { cartStatus: string }>(
      {
        query: ({ cartStatus }) =>
        `https://superadminhttps-getallcarts-${API_BASE_DOMAIN}-uc.a.run.app?status=${cartStatus}&sortDisplay=false&order=desc`,
      }
    ),
    getCartSearchResults: builder.mutation<GetSearchCart, any>({
      query: (data) => ({
        url: `https://${ALGOLIA_APP_ID}-dsn.algolia.net/1/indexes/CartSearchDocuments/query`,
        method: "POST",
        body: data,
        headers: {
          "X-Algolia-Application-Id": `${ALGOLIA_APP_ID}`,
          "X-Algolia-API-Key":
            `${ALGOLIA_API_KEY}`,
        },
      }),
    }),
    updateCartStatus: builder.mutation<any, UpdateCartRequest>({
      query: ({ cartId, cartStatus }) => ({
        url: `https://superadminhttps-updatecartstatus-${API_BASE_DOMAIN}-uc.a.run.app/`,
        method: "PUT",
        body: {
          cartId: cartId,
          status: cartStatus,
        },
        responseHandler: (response) => response.text(),
      }),
    }),
    updateCartDetails: builder.mutation<any, UpdateCartDetailsRequest>({
      query: ({ cartId, displayName, restaurantIds, merchantId, cartLocation, isFixedLocation,abbreviation,address,supportedChannels,cartType,deliveryCartsIds }) => ({
        url: `https://superadminhttps-updatecartdata-${API_BASE_DOMAIN}-uc.a.run.app`,
        method: "PUT",
        body: {
          cartId,
          displayName,
          restaurantIds,
          merchantId,
          cartLocation,
          isFixedLocation,
          abbreviation,
          address,
          supportedChannels,
          cartType,
          deliveryCartsIds
        },
        
      }),
    }),
    getCartDetailsById: builder.query({
      query: (cartId) =>
        `https://superadminhttps-getcartbycartid-${API_BASE_DOMAIN}-uc.a.run.app/?cartId=${cartId}`,
    }),
    UploadCartLogoFileExtntionHttps: builder.mutation<
      LogoFileExtntionResponse,
      LogoFileExtntionRequest
    >({
      query: (data) => ({
        url: `https://carthttps-getcartimageuploadurlhttps-${API_BASE_DOMAIN}-uc.a.run.app/`,
        method: "POST",
        body: data,
      }),
    }),
    updateCartImage: builder.mutation<any, CartImageUpdateRequest>({
      query: (data) => ({
        url: `https://superadminhttps-updatecartimage-${API_BASE_DOMAIN}-uc.a.run.app/`,
        method: "POST",
        body: data,
        responseHandler: (response) => response.text(),
      }),
    }),
    getCartInventoryForRestaurant: builder.query({
      query: ({
        restaurantId,
        cartId,
        inventoryId,
      }: {
        restaurantId: string;
        cartId: string;
        inventoryId: string;
      }) =>
        `https://adminhttps-getcartinventorybyrestaurantid-${API_BASE_DOMAIN}-uc.a.run.app?cartId=${cartId}&restId=${restaurantId}&InventId=${inventoryId}`,
    }),
    createCartPerson: builder.mutation<any, CreateCartPerson>({
      query: (data) => ({
        url: `https://superadminhttps-createcartperson-${API_BASE_DOMAIN}-uc.a.run.app/`,
        method: "POST",
        body: data,
        responseHandler: (response) => response.json(),
      }),
    }),
    createCart: builder.mutation<any, CreateCart>({
      query: (data) => ({
        url: `https://carthttps-createcart-${API_BASE_DOMAIN}-uc.a.run.app/`,
        method: "POST",
        body: data,
        responseHandler: (response) => response.json(),
      }),
    }),
    getPurchaseWalletTransactions: builder.query({
      query: ({ cartId, startDate }: { cartId?: string; startDate: string }) =>
        `https://superadminhttps-getpurchasewallettransactionlist-${API_BASE_DOMAIN}-uc.a.run.app/?cartId=${cartId}&startDate=${startDate}`,
    }),
    getSalesWalletTransactions: builder.query({
      query: ({ cartId, startDate }: { cartId: string; startDate: string }) =>
        `https://superadminhttps-getsaleswallettransactionlist-${API_BASE_DOMAIN}-uc.a.run.app/?cartId=${cartId}&startDate=${startDate}`,
    }),
    UploadCartPersonImageFileExtntionHttps: builder.mutation<
      LogoFileExtntionResponse,
      LogoFileExtntionRequest
    >({
      query: (data) => ({
        url: `https://carthttps-getcartpersonimageurl-${API_BASE_DOMAIN}-uc.a.run.app/`,
        method: "POST",
        body: data,
      }),
    }),
    getWalletDetails: builder.query({
      query: (cartId: string) =>
        `https://superadminhttps-getcartwalletbalance-${API_BASE_DOMAIN}-uc.a.run.app/?cartPersonId=${cartId}`,
    }),
    UploadCartPersonIdentityDocumentFileExtntionHttps: builder.mutation<
      LogoFileExtntionResponse,
      CartPersonIdentityDocumentExtntionRequest
    >({
      query: (data) => ({
        url: `https://carthttps-getcartpersonidentitydocurl-${API_BASE_DOMAIN}-uc.a.run.app/`,
        method: "POST",
        body: data,
      }),
    }),
    updateCartStatusOnline: builder.mutation<any, CartStatusOnline>({
      query: ({ cartId, cartState, reasonForBeingOffline }) => ({
        url: `https://carthttps-updatecartstate-${API_BASE_DOMAIN}-uc.a.run.app/`,
        method: "PUT",
        body: {
          cartId,
          cartState,
          reasonForBeingOffline
        },
      })
    }),
    getAllCartPerson: builder.query({
      query: () =>
        `https://superadminhttps-getcartpersonlist-${API_BASE_DOMAIN}-uc.a.run.app`,
    }),
    getCartPersonDetailsById: builder.query({
      query: (cartPersonId) =>
        `https://carthttps-getcartpersonbyid-${API_BASE_DOMAIN}-uc.a.run.app?id=${cartPersonId}`
    }),
    updateCartPersonDetails: builder.mutation<any, any>({
      query: (data) => ({
        url: `https://carthttps-updatecartperson-${API_BASE_DOMAIN}-uc.a.run.app`,
        method: "POST",
        body: data,
        responseHandler: (response) => response.text(),
      }),
    }),
    assignCartPersons: builder.mutation<any, CartPersonAssign>({
      query: (data) => ({
        url: `https://carthttps-assigncarttocartperson-${API_BASE_DOMAIN}-uc.a.run.app`,
        method: "POST",
        body: data,
        responseHandler: (response) => response.text(),
      }),
    }),
    nonAssignCartPersons: builder.mutation<any, CartPersonNonAssign>({
      query: (data) => ({
        url: `https://carthttps-unassigncartfromcartperson-${API_BASE_DOMAIN}-uc.a.run.app`,
        method: "POST",
        body: data,
        responseHandler: (response) => response.text(),
      }),
    }),
    updateCartPersonImage: builder.mutation<any, CartPersonImageUpdateRequest>({
      query: (data) => ({
        url: `https://superadminhttps-updatecartpersonimage-${API_BASE_DOMAIN}-uc.a.run.app`,
        method: "POST",
        body: data,
        responseHandler: (response) => response.text(),
      }),
    }),
    getOtpKey: builder.query({
      query: () =>
        `https://userhttps-getotpkey-${API_BASE_DOMAIN}-uc.a.run.app`
    }),
    updateCartPersonBankData: builder.mutation<any, cartPersonBankDataUpdateRequest>({
      query: (data) => ({
        url: `https://superadminhttps-addbankdataofcartperson-${API_BASE_DOMAIN}-uc.a.run.app/`,
        method: "PUT",
        body: data,
        responseHandler: (response) => response.text(),
      }),
    }),
    updateCartPersonWallet: builder.mutation<any, cartPersonWalletUpdateRequest>({
      query: (data) => ({
        url: `https://superadminhttps-updatedepositincartpersonpurchase-${API_BASE_DOMAIN}-uc.a.run.app/`,
        method: "POST",
        body: data,
        responseHandler: (response) => response.text(),
      })
    }),
    settleCartPayment: builder.mutation<any, SettleCartPaymentRequest>({
      query: ({ cartId, amount, restaurantId }) => ({
        url: `https://adminhttps-settlecartpayabletoplatform-${API_BASE_DOMAIN}-uc.a.run.app/`,
        method: "POST",
        body: {
          cartId,
          amount,
          restaurantId,
        },
      }),
    }),
  }),
});

export const {
  useGetAllCartDetailsQuery,
  useLazyGetAllCartDetailsQuery,
  useGetCartsByStatusMutation,
  useGetCartSearchResultsMutation,
  useUpdateCartStatusMutation,
  useUpdateCartDetailsMutation,
  useGetCartDetailsByIdQuery,
  useLazyGetCartDetailsByIdQuery,
  useUploadCartLogoFileExtntionHttpsMutation,
  useUpdateCartImageMutation,
  useGetCartInventoryForRestaurantQuery,
  useLazyGetCartInventoryForRestaurantQuery,
  useCreateCartPersonMutation,
  useCreateCartMutation,
  // useGetPurchaseWalletTransactionsQuery,
  useLazyGetPurchaseWalletTransactionsQuery,
  // useGetSalesWalletTransactionsQuery,
  useLazyGetSalesWalletTransactionsQuery,
  useUploadCartPersonImageFileExtntionHttpsMutation,
  useGetWalletDetailsQuery,
  useLazyGetWalletDetailsQuery,
  useUploadCartPersonIdentityDocumentFileExtntionHttpsMutation,
  useUpdateCartStatusOnlineMutation,
  useGetAllCartPersonQuery,
  useLazyGetAllCartPersonQuery,
  useGetCartPersonDetailsByIdQuery,
  useLazyGetCartPersonDetailsByIdQuery,
  useUpdateCartPersonDetailsMutation,
  useAssignCartPersonsMutation,
  useNonAssignCartPersonsMutation,
  useUpdateCartPersonImageMutation,
  useGetOtpKeyQuery,
  useLazyGetOtpKeyQuery,
  useUpdateCartPersonBankDataMutation,
  useUpdateCartPersonWalletMutation,
  useSettleCartPaymentMutation,
} = cartSearchService;